.floating {
  position: fixed;
  z-index: var(--z-floating);
}
